import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Alert,
} from "@mui/material";
import axios from "axios";

const MlConnect = ({ firebaseUser }) => {
  const [status, setStatus] = useState("loading"); // "loading" | "connected" | "disconnected" | "error"
  const [mlAccount, setMlAccount] = useState(null);
  const [searchParams] = useSearchParams();

  const APP_ID = process.env.REACT_APP_ML_CLIENT_ID;
  const appID = process.env.REACT_APP_ML_CLIENT_ID;

  useEffect(() => {
    const code = searchParams.get("code") || null;
    if (!firebaseUser) return;

    checkStatus(code);
  }, [firebaseUser, searchParams]);

  const checkStatus = async (code) => {
    setStatus("loading");

    const configRef = doc(
      db,
      "xpress_mercadoLibre_connectios",
      firebaseUser.uid
    );
    const configSnap = await getDoc(configRef);

    if (configSnap.exists()) {
      const data = configSnap.data();
      const isExpired = data.expires_at && Date.now() > data.expires_at;

      if (data.access_token && !isExpired) {
        setMlAccount(data);
        setStatus("connected");
        return;
      }
    }

    if (code) {
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: process.env.REACT_APP_ML_CONNETC_DEV,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_BICCIEXPREE_ENCODE}`,
        },
        data: {
          companyID: process.env.REACT_APP_BXTOKETN,
          code,
          uid: firebaseUser.uid,
          appID,
        },
      };

      try {
        const response = await axios.request(config);

        if (response.status === 200) {
          await checkStatus(null); // Recargar estado desde Firestore
        } else {
          setStatus("error");
          console.error(`❌ Error: ${response.status}`, response.data);
        }
      } catch (error) {
        setStatus("error");

        if (axios.isAxiosError(error)) {
          console.error(
            "❌ Axios error:",
            error.response?.status,
            error.response?.data
          );
        } else {
          console.error("❌ Error desconocido:", error);
        }
      }
    } else {
      setStatus("disconnected");
    }
  };

  const redirectToMeli = () => {
    const redirectUri = "https://bicciexpress.cl/dashboard/ml_connect";
    const url = `https://auth.mercadolibre.cl/authorization?response_type=code&client_id=${APP_ID}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}`;
    window.location.href = url;
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        minHeight: 500,
        margin: "auto",
        mt: 4,
        p: 3,
        boxShadow: 2,
        borderRadius: 2,
        backgroundColor: "#fff",
        verticalAlign: "middle",
      }}
    >
      <Typography variant="h5" gutterBottom>
        Integración con Mercado Libre
      </Typography>
      <Box
        sx={{
          flexGrow: 1,
          mt: 2,
          flexDirection: "column",
          alignItems: "center",
          verticalAlign: "middle",
          display: "flex",
        }}
      >
        {status === "loading" && <CircularProgress />}
        {status === "error" && (
          <Alert severity="error">Error al conectar con Mercado Libre.</Alert>
        )}
        {status === "connected" && mlAccount && (
          <>
            <Alert severity="success">
              ✅ Conectado como: {mlAccount.user_id}
            </Alert>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Ya puedes consultar publicaciones, órdenes y más desde el backend.
            </Typography>
          </>
        )}
        {status === "disconnected" && (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={redirectToMeli}
          >
            Conectar ahora
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MlConnect;
